/** @format */

import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { ProblemPriority, ProblemReceived, ProblemSource, ProblemSubType } from '../../state-management';

@Component({
    selector: 'app-addcase-description',
    templateUrl: './addcase-description.component.html',
    styleUrls: ['./addcase-description.component.scss'],
    standalone: false,
})
export class AddcaseDescriptionComponent implements OnInit, AfterViewInit {
	@Input() fg: UntypedFormGroup;
	@Input() sources: ProblemSource[];
	@Input() receivedFromList: ProblemReceived[];
	@Input() selectedProblemSubTypes: ProblemSubType[];
	@Input() priorities: ProblemPriority[];
	@Input() problemDescriptionMaxLength: number;
	@Input() notifyAssignees: boolean;
	@Input() subTypesRequired: boolean;

	orderedReceievedFromList: ProblemReceived[] = [];
	activeSourcesList: ProblemSource[];
	activeReceivedFromList: ProblemReceived[] = [];

	constructor() {}

	ngOnInit() {
		if (this.receivedFromList.length > 0) {
			let businessIndex = this.receivedFromList.findIndex((rf) => rf.problemReceivedFrom_Name === 'Business');
			let businessEntry = this.receivedFromList.find((rf) => rf.problemReceivedFrom_Name === 'Business');
			let mayorCouncilIndex = this.receivedFromList.findIndex((rf) => rf.problemReceivedFrom_Name === 'Mayor and Council');

			// extract business as we want it positioned after the mayor and council option
			let receivedFromEntriesItemsRemoved = [
				...this.receivedFromList.slice(0, businessIndex),
				...this.receivedFromList.slice(businessIndex + 1),
			];

			// create a new list with the entries till mayor and council / business entry / remaining list
			this.orderedReceievedFromList = [
				...receivedFromEntriesItemsRemoved.slice(0, mayorCouncilIndex + 1),
				businessEntry,
				...receivedFromEntriesItemsRemoved.slice(mayorCouncilIndex + 1),
			];

			this.activeReceivedFromList = this.orderedReceievedFromList.filter((prf) => prf.active);

			this.fg.get('problemReceivedFrom').setValue(this.activeReceivedFromList.find((rf) => rf.problemReceivedFrom_Name === 'Resident') || '');
		}

		if(this.sources.length > 0){
			this.activeSourcesList = this.activeSources();
		}
	}

	ngAfterViewInit() {
		// Set the medium level to selected
		if (this.priorities.length > 0) {
			this.fg.get('problemPriority').setValue(this.priorities[1]);
		}
	}

	activeSources() {
		return this.sources.filter((s) => s.active);
	}

	// activeReceivedFromList() {
	// 	return this.orderedReceievedFromList.filter((prf) => prf.active);
	// }
}
